import { render, staticRenderFns } from "./RegisterConfirm.vue?vue&type=template&id=3227977c&"
import script from "./RegisterConfirm.vue?vue&type=script&lang=ts&"
export * from "./RegisterConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports